import React, { memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid, Card, CardHeader, CardContent, TextField, Divider, IconButton, Typography, Button } from "@mui/material";
import { AddCircle, Delete } from "@mui/icons-material";
import { editProperty, selectPropertyById, propertyDeleted } from "./propertySlice";
import { selectTiersByPropertyId, tierAdded, tierDeleted, clearTiersByProperty } from "./tiersSlice"
import { Tier } from "./Tier";

const WrappedComponent = ({ id, index }) => {
	const dispatch = useDispatch();
	const tiers = useSelector(state => selectTiersByPropertyId(state, id));
	const property = useSelector(state => selectPropertyById(state, id));

	const onChange = (e) => {
		dispatch(editProperty({id, changes: {code: e.target.value}}));
	};

	const deleteProperty = () => {
		dispatch(propertyDeleted(id));
		dispatch(clearTiersByProperty(id));
	};

	return (
		<fieldset style={{position: "relative", padding: 16, margin: "16px 0", borderRadius: 8, border: ".5px solid rgba(0, 0, 0, 0.5)"}}>
			<legend>
				<Typography>Property {index + 1}</Typography>
			</legend>
			{id > 0 && <legend style={{position: "absolute", right: -19, top: -32, background: "#FFFFFF", padding: 0}}>
				<IconButton sx={{border: "1px solid"}} color="error" onClick={deleteProperty}><Delete/></IconButton>
			</legend>}
			<Grid container spacing={2}>
				{Object.keys(tiers).map((tier) =>
					<Grid key={`property_${id}_tier_${tier}`} item xs={3}>
						<Card sx={{position: "relative", pt: 4}}>
							<Box sx={{
								position: "absolute", left: 0, top: 0, py: .5, px: 1, borderRadius: 1, bgcolor: "rgb(0 85 140 / 20%)", color: "primary.main"
							}}>Tier {Number(tier) + 1}</Box>
							{(Number(tier) === Object.keys(tiers).length-1 && Number(tier) > 0) && <Box sx={{position: "absolute", right: 0, top: 0}}>
								<IconButton color="error" size="small" onClick={() => dispatch(tierDeleted(tiers[tier].id))}><Delete/></IconButton>
							</Box>}
							<CardHeader title={<TextField label="Property Code" value={property.code} {...{onChange}} InputLabelProps={{shrink: !!property.code}} />} />
							<Divider/>
							<CardContent>
								<Tier id={tiers[tier].id} />
							</CardContent>
						</Card>
					</Grid>
				)}
				{Object.keys(tiers).length < 4 &&
					<Grid item xs={3}>
						<Button
							variant="contained"
							color="success"
							onClick={() => dispatch(tierAdded({id}))}
							sx={{
								p: 3,
								display: "flex", alignItems: "center", justifyContent: "center",
								boxShadow: "rgba(46, 125, 50, .2) 0px 0px 10px",
								height: "100%",
								width: "100%",
								borderRadius: 2
							}}
						>
							<AddCircle sx={{mr: 1}} />
							<Typography variant="button">Add Tier</Typography>
						</Button>
					</Grid>
				}
			</Grid>
		</fieldset>
	)
};

export const Property = memo(WrappedComponent);